<template>
    <div class="seaRescue-div">
        <div>
            <el-button class="base-button" size="mini" type="primary" @click="start">开始</el-button>
        </div>
        <div class="step-room">
            <el-steps space="40" direction="vertical" :active="active">
                <el-step title="发现事故地点"></el-step>
                <el-step title="事故船只发送信号"></el-step>
                <el-step title="救援中心下达指令"></el-step>
                <el-step title="救援力量出发救援"></el-step>
                <el-step title="处理泄漏事故"></el-step>
                <el-step title="完成营救"></el-step>
            </el-steps>
        </div>
    </div>
</template>

<script>
import TilesetLayer from "@/utils/cesiumBD/layer/TilesetLayer.js";
import Workflow from "@/utils/cesiumBD/utils/Workflow"
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation"
var tiles3dLayerArr = [];
var entityArr = [];
export default {
    data() {
        return {
            active: undefined
        };
    },

    mounted() {
        // this.addShips();
        // this.startPathAnimation_JY1();
        // this.startPathAnimation_JY2();
    },

    methods: {
        remove3dLayerArr() {
            tiles3dLayerArr.forEach((item) => {
                item.remove(true);
            });

            tiles3dLayerArr = [];
        },
        removeEntityArr() {
            entityArr.forEach((item) => {
                viewer.entities.remove(item);
            });

            entityArr = [];
        },
        start() {
            this.remove3dLayerArr();
            this.removeEntityArr();
            var funs = [];
            funs.push({ fun: this.step1, delay: 800, params: {} });
            funs.push({ fun: this.step2, delay: 5 * 1000, params: {} });
            funs.push({ fun: this.step3, delay: 5 * 1000, params: {} });
            funs.push({ fun: this.step4, delay: 5 * 1000, params: {} });
            funs.push({ fun: this.step5, delay: 3 * 1000, params: {} });
            funs.push({ fun: this.step6, delay: 5 * 1000, params: {} });
            funs.push({ fun: this.step7, delay: 2 * 1000, params: {} });
            var ws = new Workflow(funs);
            ws.runWorkflow();
        },
        startPlay() {
            this.sendMsg();//
            this.addWarn();//
            this.addOilWave();//
            this.addZHZX(); //
            this.addLeiDa(); //
            this.addkongZhongLl(); //
            this.addShips();

        },

        step1() {
            var view = {
                "y": 29.797203,
                "x": 126.255761,
                "z": 410378.61,
                "heading": 12.7,
                "pitch": -60.5,
                "roll": 0
            }

            return new Promise((resolve) => {
                this.active = 0;
                this.addWarn();
                this.addOilWave();
                DBmap.setCameraView(view);
                resolve();
            });
        },

        step2() {

            var view = {
                "y": 17.930254,
                "x": 129.23311,
                "z": 1233159.21,
                "heading": 350,
                "pitch": -34.9,
                "roll": 0
            }

            return new Promise((resolve) => {
                this.active = 1;
                this.addkongZhongLl();
                this.sendMsg();
                DBmap.setCameraView(view);
                resolve();
            });
        },
        step3() {

            var view = {
                "y": 33.343012,
                "x": 102.944041,
                "z": 631102.95,
                "heading": 83.3,
                "pitch": -20.5,
                "roll": 360
            }

            return new Promise((resolve) => {
                this.active = 2;
                this.addZHZX();
                this.addLeiDa();
                this.sendZL();
                DBmap.setCameraView(view);
                resolve();
            });
        },
        step4() {

            var view = {
                "y": 29.270942,
                "x": 123.274906,
                "z": 2495978.08,
                "heading": 357,
                "pitch": -89.9,
                "roll": 0
            }

            return new Promise((resolve) => {
                this.active = 3;
                this.addShips();
                var animation = this.startPathAnimation_BJ();
                this.startPathAnimation_YL();
                this.startPathAnimation_JY1();
                this.startPathAnimation_JY2();
                DBmap.setCameraView(view);

                var interval = setInterval(() => {
                    if (Cesium.JulianDate.greaterThanOrEquals(viewer.clock.currentTime, animation.endTime)) {
                        resolve();
                        clearInterval(interval);
                    }
                }, 200);
            });
        },

        step5() {

            var view = {
                "y": 32.721458,
                "x": 127.910442,
                "z": 3979777.7,
                "heading": 2.6,
                "pitch": -89.7,
                "roll": 0
            }
            var that = this;
            return new Promise((resolve) => {
                this.active = 4;
                clearInterval(that.warnTimer);
                viewer.entities.remove(that.warnIcon);
                DBmap.setCameraView(view);
                resolve();
            });
        },

        step6() {

            var view = {
                "y": 32.721458,
                "x": 127.910442,
                "z": 3979777.7,
                "heading": 2.6,
                "pitch": -89.7,
                "roll": 0
            }
            var that = this;
            return new Promise((resolve) => {
                this.active = 5;
                that.remove3dLayerArr();
                that.removeEntityArr();
                resolve();
            });
        },
        step7() {
            return new Promise((resolve) => {
                this.active = 6;
                resolve();
            });
        },
        startPathAnimation_BJ() {
            var positions = Cesium.Cartesian3.fromDegreesArray([121.64, 26.03, 125.989481, 27.620443, 126.6, 32.1]);
            var animation = new PathAnimation({
                entity: this['BJ'],
                positions: positions,
                speed: 800,
                multiple: 150,
                height: 0
            });

            animation.start();

            var material = new Cesium.PolylineTrailLinkMaterialProperty(
                {
                    color: new Cesium.Color(255 / 255, 204 / 255, 102 / 255, 0.5),
                    duration: 3000,
                    image: "data/img/effects/line-arrow-blue.png"
                }
            )

            const entity = new Cesium.Entity({
                polyline: {
                    positions: positions,
                    show: true,
                    material: material,
                    width: 20,
                    clampToGround: false,
                    disableDepthTestDistance: Number.MAX_VALUE,
                },
            });

            entityArr.push(entity);
            viewer.entities.add(entity);

            return animation;
        },

        startPathAnimation_YL() {
            var positions = Cesium.Cartesian3.fromDegreesArray([121.94, 27.03, 126.6, 32.1]);
            var animation = new PathAnimation({
                entity: this['YL'],
                positions: positions,
                speed: 800,
                multiple: 150,
                height: 0
            });

            animation.start();

            var material = new Cesium.PolylineTrailLinkMaterialProperty(
                {
                    color: new Cesium.Color(255 / 255, 204 / 255, 102 / 255, 0.5),
                    duration: 3000,
                    image: "data/img/effects/line-arrow-blue.png"
                }
            )

            const entity = new Cesium.Entity({
                polyline: {
                    positions: positions,
                    show: true,
                    material: material,
                    width: 20,
                    clampToGround: false,
                    disableDepthTestDistance: Number.MAX_VALUE,
                },
            });

            entityArr.push(entity);
            viewer.entities.add(entity);
        },
        startPathAnimation_JY1() {
            var positions = Cesium.Cartesian3.fromDegreesArray([122.24, 28.03, 126.6, 32.1]);
            var animation = new PathAnimation({
                entity: this['JY1'],
                positions: positions,
                speed: 800,
                multiple: 150,
                height: 0
            });

            animation.start();

            var material = new Cesium.PolylineTrailLinkMaterialProperty(
                {
                    color: new Cesium.Color(255 / 255, 204 / 255, 102 / 255, 0.5),
                    duration: 3000,
                    image: "data/img/effects/line-arrow-blue.png"
                }
            )

            const entity = new Cesium.Entity({
                polyline: {
                    positions: positions,
                    show: true,
                    material: material,
                    width: 20,
                    clampToGround: false,
                    disableDepthTestDistance: Number.MAX_VALUE,
                },
            });

            entityArr.push(entity);
            viewer.entities.add(entity);
        },
        startPathAnimation_JY2() {
            var positions = Cesium.Cartesian3.fromDegreesArray([122.54, 29.03, 126.6, 32.1]);
            var animation = new PathAnimation({
                entity: this['JY2'],
                positions: positions,
                speed: 800,
                multiple: 150,
                height: 0
            });

            animation.start();

            var material = new Cesium.PolylineTrailLinkMaterialProperty(
                {
                    color: new Cesium.Color(255 / 255, 204 / 255, 102 / 255, 0.5),
                    duration: 3000,
                    image: "data/img/effects/line-arrow-blue.png"
                }
            )

            const entity = new Cesium.Entity({
                polyline: {
                    positions: positions,
                    show: true,
                    material: material,
                    width: 20,
                    clampToGround: false,
                    disableDepthTestDistance: Number.MAX_VALUE,
                },
            });

            entityArr.push(entity);
            viewer.entities.add(entity);
        },
        //发送信号
        sendMsg() {
            var positions = [
                [127, 31.83, 14000],
                [120, 36, 550000]
            ];

            var material = new Cesium.PolylineTrailLinkMaterialProperty(
                {
                    color: new Cesium.Color(255 / 255, 204 / 255, 102 / 255, 0.5),
                    duration: 3000,
                    image: "data/img/effects/line-tarans.png"
                }
            )
            const entity = new Cesium.Entity({
                polyline: {
                    positions: Cesium.Cartesian3.fromDegreesArrayHeights([127, 31.83, 14000, 120, 36, 550000]),
                    show: true,
                    material: material,
                    width: 10,
                    clampToGround: false,
                    disableDepthTestDistance: Number.MAX_VALUE,
                },
            });

            entityArr.push(entity);
            viewer.entities.add(entity);
        },
        //下达指令
        sendZL() {

            var material = new Cesium.PolylineTrailLinkMaterialProperty(
                {
                    color: new Cesium.Color(255 / 255, 204 / 255, 102 / 255, 0.5),
                    duration: 3000,
                    image: "data/img/effects/line-gradual.png"
                }
            )
            const entity = new Cesium.Entity({
                polyline: {
                    positions: Cesium.Cartesian3.fromDegreesArrayHeights([120, 36, 550000, 117.3, 38, 14000, 117.1, 33, 14000]),
                    show: true,
                    material: material,
                    width: 10,
                    clampToGround: false,
                    disableDepthTestDistance: Number.MAX_VALUE,
                },
            });

            entityArr.push(entity);
            viewer.entities.add(entity);
        },
        addWarn() {
            var position = Cesium.Cartesian3.fromDegrees(126.320842, 31.97364, 14000);
            const entity = new Cesium.Entity({
                position: position,
                billboard: {
                    image: "data/img/marker/warn.png",
                    scale: 1.0,
                    horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                    clampToGround: true
                },
            });

            entityArr.push(entity);
            viewer.entities.add(entity);
            this.warnTimer = setInterval(() => {
                entity.show = !entity.show
            }, 500)
            this.warnIcon = entity;
            return entity;
        },
        //添加油污扩散波
        addOilWave() {
            // var material = new Cesium.DynamicCircleBMaterialProperty({
            //     color: new Cesium.Color(1.0, 0.0, 0.0, 1),
            //     time: 2,
            //     count: 4,
            //     gradient: 0.2
            // });

            var material = new Cesium.DynamicCircleAMaterialProperty({
                color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                time: 2
            });

            var position = Cesium.Cartesian3.fromDegrees(127, 31.83, 10);
            const entity = new Cesium.Entity({
                position: position,
                label: {
                    text: "事故船只",
                    font: '15px sans-serif',
                    style: Cesium.LabelStyle.FILL,
                    showBackground: true,
                    backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                    pixelOffset: new Cesium.Cartesian2(0.0, -40.0),
                    outlineWidth: 1,
                    fillColor: Cesium.Color.DARKORANGE,
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    disableDepthTestDistance: Number.MAX_VALUE,
                },
                model: {
                    uri: "data/mx/ship03.glb", //模型的地址 
                    // scale: 5000, //模型缩放比例
                    minimumPixelSize: 70,// 60,
                    maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
                    incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
                    runAnimations: true, // 是否应启动模型中指定的glTF动画
                    clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
                    shadows: Cesium.ShadowMode.ENABLED,
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND //设置模型贴地,
                },
                ellipse: {
                    semiMajorAxis: 120000.0,
                    semiMinorAxis: 120000.0,
                    // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                    material: material,
                    outline: false,
                    outlineColor: Cesium.Color.RED,
                },

            });

            entityArr.push(entity);
            viewer.entities.add(entity);
        },
        //添加指挥中心
        addZHZX() {
            // 添加建筑
            const buildPositions = [
                { lat: 38, lng: 117.3, name: "海事局" },
                { lat: 33, lng: 117.1, name: "指挥中心" },
                { lat: 30, lng: 116.5, name: "智能中心" }
            ]
            buildPositions.forEach((e) => {
                var position = Cesium.Cartesian3.fromDegrees(e.lng, e.lat, 10000);
                var tiles3dLayer = new TilesetLayer({
                    "name": e.name,
                    "url": "http://data.mars3d.cn/3dtiles/bim-daxue/tileset.json",
                    "position": {
                        x: e.lng,
                        y: e.lat,
                        z: 10
                    },
                    "dynamicScreenSpaceError": true,
                    "cullWithChildrenBounds": false,
                    maximumScreenSpaceError: 16,
                    maximumMemoryUsage: 1024,
                    autoAdd: true,
                    scale: 1000,
                })

                tiles3dLayer.scale = 1000;
                tiles3dLayerArr.push(tiles3dLayer);


                const entity = new Cesium.Entity({
                    position: position,
                    label: {
                        text: e.name,
                        font: '25px sans-serif',
                        style: Cesium.LabelStyle.FILL,
                        showBackground: true,
                        backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                        pixelOffset: new Cesium.Cartesian2(0.0, -40.0),
                        outlineWidth: 1,
                        fillColor: Cesium.Color.WHITE,
                        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                        disableDepthTestDistance: Number.MAX_VALUE,
                    }

                });

                entityArr.push(entity);
                viewer.entities.add(entity);
            })
        },
        addLeiDa() {
            // 添加基岸雷达
            const leiDaPositions = [
                {
                    position: [120.3479992508, 28.4277417126],
                    name: "基岸雷达1"
                },
                {
                    position: [120.098207771, 30.2945074558],
                    name: "基岸雷达2"
                },
                {
                    position: [120.1278554546, 32.4739348842],
                    name: "基岸雷达3"
                },
                {
                    position: [119.6090489248, 33.9603970691],
                    name: "基岸雷达4"
                },
                {
                    position: [119.563892164, 35.9884519627],
                    name: "基岸雷达5"
                }
            ]
            leiDaPositions.forEach((e) => {
                var position = Cesium.Cartesian3.fromDegrees(e.position[0], e.position[1], 880);
                const entity = new Cesium.Entity({
                    position: position,
                    label: {
                        text: e.name,
                        font: '15px sans-serif',
                        style: Cesium.LabelStyle.FILL,
                        showBackground: true,
                        backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                        pixelOffset: new Cesium.Cartesian2(0.0, -40.0),
                        outlineWidth: 1,
                        fillColor: Cesium.Color.RED,
                        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                        disableDepthTestDistance: Number.MAX_VALUE,
                    },
                    model: {
                        uri: "data/mx/leida.glb", //模型的地址 
                        scale: 1, //模型缩放比例
                        minimumPixelSize: 60,// 60,
                        maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
                        incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
                        runAnimations: true, // 是否应启动模型中指定的glTF动画
                        clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
                        shadows: Cesium.ShadowMode.ENABLED,
                        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND //设置模型贴地,
                    }

                });

                entityArr.push(entity);
                viewer.entities.add(entity);
            })
        },
        addkongZhongLl() {
            const entity_wx = new Cesium.Entity({
                position: Cesium.Cartesian3.fromDegrees(120, 36, 550000),
                model: {
                    uri: "data/mx/weixin.gltf", //模型的地址 
                    scale: 100, //模型缩放比例
                    minimumPixelSize: 60,// 60,
                    maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
                    incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
                    runAnimations: true, // 是否应启动模型中指定的glTF动画
                    clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
                    shadows: Cesium.ShadowMode.ENABLED,
                    //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND //设置模型贴地,
                },
                //weixin.gltf
                label: {
                    text: "北斗卫星",
                    font: '25px sans-serif',
                    style: Cesium.LabelStyle.FILL,
                    showBackground: true,
                    backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                    pixelOffset: new Cesium.Cartesian2(0.0, -40.0),
                    outlineWidth: 1,
                    fillColor: Cesium.Color.DARKORANGE,
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    disableDepthTestDistance: Number.MAX_VALUE,
                }

            });

            entityArr.push(entity_wx);
            viewer.entities.add(entity_wx);


            const entity_fj1 = new Cesium.Entity({
                position: Cesium.Cartesian3.fromDegrees(124, 33.1, 550000),
                model: {
                    uri: "data/mx/wrj.glb", //模型的地址 
                    scale: 100, //模型缩放比例
                    minimumPixelSize: 60,// 60,
                    maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
                    incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
                    runAnimations: true, // 是否应启动模型中指定的glTF动画
                    clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
                    shadows: Cesium.ShadowMode.ENABLED,
                    //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND //设置模型贴地,
                },
                //weixin.gltf
                label: {
                    text: "飞机1",
                    font: '25px sans-serif',
                    style: Cesium.LabelStyle.FILL,
                    showBackground: true,
                    backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                    pixelOffset: new Cesium.Cartesian2(0.0, -40.0),
                    outlineWidth: 1,
                    fillColor: Cesium.Color.DARKORANGE,
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    disableDepthTestDistance: Number.MAX_VALUE,
                },
                cylinder: {
                    length: 550000, //圆锥高度
                    topRadius: 0.0, //顶部半径
                    bottomRadius: 550000 * 0.3, //底部半径
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                    material: new Cesium.RadarRadiationWaveMaterialProperty(
                        {
                            color: new Cesium.Color(1.0, 1.0, 0.0, 1),
                            repeat: 15,
                            offset: 0,
                            thickness: 0.3,
                            duration: 3000,
                        }), //
                },

            });

            entityArr.push(entity_fj1);
            viewer.entities.add(entity_fj1);
        },
        addShips() {
            // 添加船
            const shipPositions = [
                {
                    position: [121.64, 26.03],
                    name: "补给船",
                    tgName: "BJ"
                },
                {
                    position: [121.94, 27.03],
                    name: "医疗船",
                    tgName: "YL"
                },
                {
                    position: [122.24, 28.03],
                    name: "救援船1",
                    tgName: "JY1"
                },
                {
                    position: [122.54, 29.03],
                    name: "救援船2",
                    tgName: "JY2"
                },
                {
                    position: [126.54, 27.03],
                    name: "货001"
                },
                {
                    position: [127.24, 32.03],
                    name: "货002"
                },
                {
                    position: [128.54, 29.03],
                    name: "货003"
                },
                {
                    position: [122.54, 34.03],
                    name: "货004"
                }
            ]


            shipPositions.forEach((e) => {
                var position = Cesium.Cartesian3.fromDegrees(e.position[0], e.position[1], 10);
                const entity = new Cesium.Entity({
                    position: position,
                    label: {
                        text: e.name,
                        font: '15px sans-serif',
                        style: Cesium.LabelStyle.FILL,
                        showBackground: true,
                        backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
                        pixelOffset: new Cesium.Cartesian2(0.0, -40.0),
                        outlineWidth: 1,
                        fillColor: Cesium.Color.DARKORANGE,
                        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                        disableDepthTestDistance: Number.MAX_VALUE,
                    },
                    model: {
                        uri: "data/mx/ship04.glb", //模型的地址 
                        // scale: 5000, //模型缩放比例
                        minimumPixelSize: 60,// 60,
                        maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
                        incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
                        runAnimations: true, // 是否应启动模型中指定的glTF动画
                        clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
                        shadows: Cesium.ShadowMode.ENABLED,
                        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND //设置模型贴地,
                    }

                });

                entityArr.push(entity);
                viewer.entities.add(entity);
                if (e.tgName) {
                    this[e.tgName] = entity;
                }
            })
        },
        //曲线坐标
        getLinkedPointList(startPoint, endPoint, angularityFactor, numOfSingleLine) {
            var result = [];

            var startPosition = Cesium.Cartographic.fromCartesian(startPoint);
            var endPosition = Cesium.Cartographic.fromCartesian(endPoint);

            var startLon = startPosition.longitude * 180 / Math.PI;
            var startLat = startPosition.latitude * 180 / Math.PI;
            var endLon = endPosition.longitude * 180 / Math.PI;
            var endLat = endPosition.latitude * 180 / Math.PI;

            var dist = Math.sqrt((startLon - endLon) * (startLon - endLon) + (startLat - endLat) * (startLat - endLat));

            //var dist = Cesium.Cartesian3.distance(startPoint, endPoint);
            var angularity = dist * angularityFactor;

            var startVec = Cesium.Cartesian3.clone(startPoint);
            var endVec = Cesium.Cartesian3.clone(endPoint);

            var startLength = Cesium.Cartesian3.distance(startVec, Cesium.Cartesian3.ZERO);
            var endLength = Cesium.Cartesian3.distance(endVec, Cesium.Cartesian3.ZERO);

            Cesium.Cartesian3.normalize(startVec, startVec);
            Cesium.Cartesian3.normalize(endVec, endVec);

            if (Cesium.Cartesian3.distance(startVec, endVec) == 0) {
                return result;
            }

            //var cosOmega = Cesium.Cartesian3.dot(startVec, endVec);
            //var omega = Math.acos(cosOmega);

            var omega = Cesium.Cartesian3.angleBetween(startVec, endVec);

            result.push(startPoint);
            for (var i = 1; i < numOfSingleLine - 1; i++) {
                var t = i * 1.0 / (numOfSingleLine - 1);
                var invT = 1 - t;

                var startScalar = Math.sin(invT * omega) / Math.sin(omega);
                var endScalar = Math.sin(t * omega) / Math.sin(omega);

                var startScalarVec = Cesium.Cartesian3.multiplyByScalar(startVec, startScalar, new Cesium.Cartesian3());
                var endScalarVec = Cesium.Cartesian3.multiplyByScalar(endVec, endScalar, new Cesium.Cartesian3());

                var centerVec = Cesium.Cartesian3.add(startScalarVec, endScalarVec, new Cesium.Cartesian3());

                var ht = t * Math.PI;
                var centerLength = startLength * invT + endLength * t + Math.sin(ht) * angularity;
                centerVec = Cesium.Cartesian3.multiplyByScalar(centerVec, centerLength, centerVec);

                result.push(centerVec);
            }

            result.push(endPoint);

            return result;
        }
    },
};
</script>

<style lang="scss" scoped>
.seaRescue-div {
    padding: 0 20px;
}
</style>
<style lang="scss">
.step-room {

    height: 400px;
    margin-top: 20px;

    .el-step.is-vertical {
        height: 200px;
    }

    .el-step__title.is-finish {
        color: #67c23a;
    }

    .el-step__title.is-process {
        font-weight: 700;
        color: #e6a23c;
    }

    .el-step__title.is-wait {
        color: #fff;
    }

}
</style>